import styled from 'styled-components'

import theme, { breakpoint } from 'style/theme'

export default styled.div`
  background: #fff0e2;
  background-image: linear-gradient(164deg, #fff0e2 3%, #ffffff 59%);

  .breadcrumb-block {
    padding: 10px 0;
    margin-top: 40px;
    margin-bottom: 10px;

    li:last-child {
      span,
      a {
        font-weight: 600;
      }
    }

    span,
    a {
      color: ${theme.darkRed} !important;
    }
  }

  .banner {
    position: relative;
    height: 480px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 40px;

    .shadow {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(112, 112, 112, 0.3);
      z-index: 1;
    }

    .cover-image {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .title {
      position: relative;
      color: ${theme.white};
      z-index: 2;
    }
  }

  .content {
    .categories-block {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 20px;
      margin-bottom: 40px;

      .ant-tag {
        border-color: ${theme.darkRed};
        .text-tag {
          color: ${theme.darkRed};
        }
      }
    }

    .image-block {
      margin-bottom: 20px;
      img {
        object-fit: cover;
      }
    }

    .title {
      color: ${theme.darkRed};
    }

    .date-block {
      margin-top: 20px;
      .text-date {
        color: ${theme.darkGray};
      }
    }

    .detail-block {
      margin-top: 40px;
      .text-detail {
        color: ${theme.darkGray};
        font-size: 16px;

        img {
          object-fit: contain;
        }
      }
    }

    .section-subscribe {
    }
  }

  .relate-block {
    margin-top: 60px;
    padding: 40px 0;
    background: rgba(255, 240, 226, 0.5);
  }

  @media (max-width: ${breakpoint.lg}) {
  }
`
